import { Component, Inject } from '@angular/core';
import { LegacyAdminDataDTO } from '../../../sub-page/minutes/interface/minute-detail';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-detalle-inge-adm',
  templateUrl: './detalle-inge-adm.component.html',
  styleUrls: ['./detalle-inge-adm.component.scss']
})
export class DetalleIngeAdmComponent {
  public dataSource: LegacyAdminDataDTO | null;

  constructor(
    public dialogRef: MatDialogRef<DetalleIngeAdmComponent>,
    @Inject(MAT_DIALOG_DATA)public data: LegacyAdminDataDTO
    ) {
      debugger;
      this.dataSource = data;
    }
    cerrarDialogo() {
      this.dialogRef.close();
    }
}
